import React from "react";
import { useSelector } from "react-redux";
import { Box, Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const LicenseDetailsFrame = () => {
  const licensedProducts =
    useSelector((state) => state.authen.loggedInUser?.licensed_products) || [];

  const columns = [
    { field: "license_name", headerName: "License", flex: 1 },
    { field: "formatted_date", headerName: "Expiration", flex: 1 },
    {
      field: "difference_in_days",
      headerName: "Days to Expiration",
      flex: 1,
      type: "number",
    },
  ];

  const rows = licensedProducts.map((product, index) => ({
    id: index,
    license_name: product.license_name,
    formatted_date: product.formatted_date,
    difference_in_days: product.difference_in_days,
  }));

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        License Details
      </Typography>

      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#f9f9f9",
            },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#ffffff",
            },
          }}
        />
      </Box>
    </Paper>
  );
};

export default LicenseDetailsFrame;
